export enum CertifyStatus {
  'Certified' = 1,
  'Verifying' = 2,
  'Uncertified' = 3,
}
export type UserInfo = {
  id: number;
  nickname: string;
  password: string;
  head_img_url: string;
  mail: string;
  passport: string;
  created_at: string;
  updated_at: string;
  wechat_nickname: string;
  is_partner: boolean;
  is_certified: CertifyStatus; // 1：已认证， 2:认证中，3:未认证
  phone?: string;
  org_id: number;
  last_logined_at: string;
};

export type UpdateUserInfo = {
  mail?: string;
  old_password?: string;
  new_password?: string;
  confirm_password?: string;
};

export type SecurityProfile = {
  has_password: boolean;
  has_phone: boolean;
  has_mail: boolean;
  has_wechat: boolean;
  security_level: string;
  factor_count: number;
  contact_factor_count: number;
  missing_factors: string[];
};

export type SecurityGate = {
  scene: string;
  pass: boolean;
  required_factor_count: number;
  factor_count: number;
  available_factors: string[];
  missing_factors: string[];
  recommended_factor: string;
};

export type SecurityOptions = {
  scene: string;
  available_verify_types: string[];
  recommended_verify_type: string;
  has_password: boolean;
  has_phone: boolean;
  has_mail: boolean;
  has_wechat: boolean;
  recovery_required: boolean;
};

export type SecurityWechatInfo = {
  scene: string;
  state: string;
  app_id: string;
  redirect_url: string;
  qr_type: 'web' | 'oa';
};

export type SecurityWechatStatus = {
  scene: string;
  state: string;
  verified: boolean;
};

export type UserVerification = {
  cert_type: IdentificationType | '';
  cert_no: string;
  cert_name: string;
};

export type UserVerificationInfo = UserVerification & {
  create_at: string;
  certify_status: number; // 1：已认证， 2:认证中，3:未认证
};

export enum IdentificationType {
  'IDENTITY_CARD' = '中华人民共和国居民身份证',
  'HOME_VISIT_PERMIT_HK_MC' = '港澳通行证',
  'HOME_VISIT_PERMIT_TAIWAN' = '台湾通行证',
  'RESIDENCE_PERMIT_HK_MC' = '港澳居住证',
  'RESIDENCE_PERMIT_TAIWAN' = '台湾居住证',
}
